import { Component, OnInit } from '@angular/core';
import { DomainService } from 'src/app/services/domain.service';
import { TestService } from 'src/app/services/test.service';
import { UserService } from 'src/app/services/user.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-forms',
  templateUrl: './forms.component.html',
  styleUrls: ['./forms.component.css']
})
export class FormsComponent implements OnInit {

  public formModel = [];
  public radioField = [];
  public multipleField = [];
  public creatingFieldType = 'text';
  public title = '';
  public option = {
    text: '',
    value: null
  }
  public successMessage = 'Gracias por su tiempo y bienvenido/a. Por favor, tómese un momento para responder algunas preguntas sin ninguna distracción a su alrededor.';
  public failMessage = 'Queremos expresar nuestro más sincero agradecimiento por haber completado nuestro formulario. Su tiempo y contribución son valiosos para nosotros, ya que nos permiten obtener información importante y mejorar nuestros servicios.';
  public value = null;
  public correctValue = null;
  public forms = [];
  public aprovationScore = 0;

  public exclude = false;

  public editingIndex = -1;
  public editingOptionIndex = -1;

  public editingFormId = null;
  public formTitle = '';
  public user;
  public selectedForm;
  public isVisible = false;
  public formFilter = '';


  constructor(
    private testService: TestService,
    private userService: UserService,
    public domainService: DomainService
  ) { }

  async ngOnInit() {
    this.user = await this.userService.getUser().toPromise();
    this.testService.getUserForms({email:this.user.email}).subscribe(
      resp=>{
        this.forms = resp;
      },
      err=>console.log(err)
    )
  }

  changeForm(f){
    if (!f){
      this.successMessage = 'Por favor, complete el siguiente formulario. Se recomienda reservar unos minutos libres de distracciones para realizarlo. Una vez que presione el botón Comenzar, no podrá salir de la pantalla hasta terminarlo. De lo contrario, la prueba quedará bloqueada.';
      this.failMessage = 'Queremos expresar nuestro más sincero agradecimiento por haber completado nuestro formulario. Su tiempo y contribución son valiosos para nosotros, ya que nos permiten obtener información importante y mejorar nuestros servicios. Saludos cordiales.';
    }
    this.isVisible = true;
    this.testService.getUserForms({email:this.user.email}).subscribe(
      resp=>{
        this.forms = resp;
      },
      err=>console.log(err)
    )
    document.getElementById('formSection').scrollIntoView({behavior:'smooth'});
    if (!f){
      this.formModel = [];
      this.editingFormId = null;
      this.formTitle = '';
      this.successMessage = '';
      this.failMessage = '';
      this.exclude = false;
      return
    }
    this.formModel = f.data;
    this.editingFormId = f._id;
    this.formTitle = f.title;
    this.successMessage = f.successMessage;
    this.failMessage = f.failMessage;
    this.exclude = f.exclude;
    
  }

  saveForm(){
    let title = this.formTitle;
    if (!title){
      Swal.fire({
        icon:'warning',
        text:'Ingrese un título'
      })
      return
    }

    let goodScore = this.checkScore(this.formModel, this.aprovationScore);
    if (!goodScore) return
    if (title){
      let obj = {
        data:this.formModel, 
        userEmail:this.user.email, 
        title:title,
        aprovationScore: this.aprovationScore,
        successMessage: this.successMessage,
        failMessage: this.failMessage,
        exclude: this.exclude
      }
      if (this.editingFormId){
        
        this.testService.updateForm({_id:this.editingFormId, ...obj}).subscribe(
          resp => {
            Swal.fire({
              icon:'success',
              text: 'Formulario actualizado',
              timer: 2000
            }).then(
              ()=>{
                location.reload()
              }
            )
          }
        )
      }else{
        let titleExist = false;
        this.forms.map(
          f=>{
            if (f.title==title) titleExist = true;
          }
        )
        if (titleExist){
          Swal.fire({
            icon:'warning',
            text:'Ya existe un formulario con ese título'
          })
          return
        }
        this.testService.createForm(obj).subscribe(
          resp=>{
            this.forms.push(resp);
          },
          err=>console.log(err)
        )
      }
    }
  }

  deleteField(i){
    this.formModel.splice(i,1);
  }

  checkScore(form, aprovationScore){
    let score = 0;
    for (let field of form){
      if (field.type=='number'){
        score += field.value;
      }
      if (field.type=='radio'){
        let maxValue = 0;
        for (let option of field.data){
          if (option.value>maxValue) maxValue = option.value;
        }
        score += maxValue;
      }
      if (field.type=='multiple'){
        let total = 0;
        for (let option of field.data){
          total += option.value;
        }
        score += total;
      }
    }
    if (score<aprovationScore){
      Swal.fire({
        icon:'warning',
        text:'La puntuación de aprobación es mayor a la puntuación total del formulario'
      })
      return false
    }
    return true;
  }

  deleteForm(){
    Swal.fire({
      text:'¿Borrar formulario?',
      showCancelButton:true
    }).then(
      resp=>{
        if (resp.isConfirmed){
          this.testService.deleteForm(this.selectedForm).subscribe(
            resp=>{
              location.reload()
            }
          )
        }
      }
    )
  }

  editField(i){
    this.editingIndex = i;
    this.creatingFieldType = this.formModel[i].type;
    this.title = this.formModel[i].text;
    if (this.formModel[i].type=='radio'){
      this.radioField = this.formModel[i].data;
    }
    if (this.formModel[i].type=='multiple'){
      this.multipleField = this.formModel[i].data;
    }
    this.value = this.formModel[i].value;
    this.correctValue = this.formModel[i].correctValue;
  }

  editOption(optionIndex: number){
    this.editingOptionIndex = optionIndex;
    this.creatingFieldType = this.formModel[this.editingIndex].type;
    if (this.creatingFieldType=='radio'){
      this.option.text = this.formModel[this.editingIndex].data[optionIndex].text;
      this.option.value = this.formModel[this.editingIndex].data[optionIndex].value;
    }
    if (this.creatingFieldType=='multiple'){
      this.option.text = this.formModel[this.editingIndex].data[optionIndex].text;
      this.option.value = this.formModel[this.editingIndex].data[optionIndex].value;
    }


  }

  createField(type){

    if (this.editingIndex != -1){
      let type = this.formModel[this.editingIndex].type;
      this.formModel[this.editingIndex].text = this.title;
      this.formModel[this.editingIndex].value = this.value;
      this.formModel[this.editingIndex].correctValue = this.correctValue;
      if (type=='radio'){
        this.formModel[this.editingIndex].data = this.radioField;
      }
      if (type=='multiple'){
        this.formModel[this.editingIndex].data = this.multipleField;
      }
      this.editingIndex = -1;
      this.title = "";
      this.value = null;
      this.correctValue = null;
      this.option.text = "";
      this.option.value = null;
      this.radioField = [];
      this.multipleField = [];
      this.creatingFieldType = '';
      return
    }
    if (type=='text'){
      this.formModel.push({type:'text', text:this.title})
      this.title = "";
      this.creatingFieldType = '';
    }

    if (type=='number'){
      this.formModel.push({type:'number', text:this.title, correctValue: this.correctValue, value:this.value})
      this.title = "";
      this.value = null;
      this.correctValue = null;
      this.creatingFieldType = '';
    }

    if (type=='radio'){
      this.formModel.push({type:'radio', text:this.title, data:this.radioField})
      this.title = "";
      this.option.text = "";
      this.option.value = null;
      this.creatingFieldType = '';
      this.radioField = [];
    }

    if (type=='multiple'){
      this.formModel.push({type:'multiple', text:this.title, data:this.multipleField})
      this.title = "";
      this.option.text = "";
      this.option.value = null;
      this.creatingFieldType = '';
      this.multipleField = [];
    }
  }

  addRadio(){
    if (this.option){
      let newOption = {
        text: this.option.text,
        value: this.option.value
      }
      if (this.editingOptionIndex != -1){
        this.radioField[this.editingOptionIndex] = newOption;
        this.editingOptionIndex = -1;
      }else{
        this.radioField.push(newOption);
      }
      this.option.text = "";
      this.option.value = null;
    }
  }

  addMultiple(){
    if (this.option){
      let newOption = {
        text: this.option.text,
        value: this.option.value
      }
      if (this.editingOptionIndex != -1){
        this.multipleField[this.editingOptionIndex] = newOption;
        this.editingOptionIndex = -1;
      }else{
        this.multipleField.push(newOption);
      }
      this.option.text = "";
      this.option.value = null;    
    }
  }

  deleteOption(i: number, type: string){
    if (type=='radio'){
      this.radioField.splice(i,1);
    }
    if (type=='multiple'){
      this.multipleField.splice(i,1);
    }
  }

}
